/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { validationSelectedPacs } from '..';

const validationStep2 = (selectedPacs: number | null) => (_.pickBy({
  validationTypeDeclaration: validationSelectedPacs(selectedPacs),
}, (v) => !_.isNil(v) && !_.isEmpty(v)));

export default validationStep2;
